// extracted by mini-css-extract-plugin
module.exports = {"wrap":"le","contentWrapCtaDefault":"me","disabled":"ne","contentWrapCtaWhite":"oe","promos":"pe","lazyPromo":"qe","mainContent":"re","headingText":"se","copy":"te","subtext":"ue"};